import { jsx as _jsx } from "react/jsx-runtime";
import { InvisibleIconRotatorWrapper } from './styles';
import { Icon } from '.';
export default function IconRotator({ rotate, ...rest }) {
    return (_jsx(InvisibleIconRotatorWrapper, { rotate: rotate, children: _jsx(Icon, { ...rest }) }));
}
//# sourceMappingURL=Rotator.js.map